module.exports = __webpack_public_path__ + "img/gox3.137cf50b.png";